import { RefObject, useEffect } from 'react';

// using-mouse class name is used to implement keyboard-only focus for interactive elements;
// amplify-styles library processes this class name to remove focus effect for mouse
export const USING_MOUSE_CLASS_NAME = 'using-mouse';

export const useMouseDetect = (elementRef: RefObject<HTMLElement>) => {
  const handleMouseMove = () => {
    elementRef.current?.classList.add(USING_MOUSE_CLASS_NAME);
  };
  const handleKeyboardKeyUp = () => {
    elementRef.current?.classList.remove(USING_MOUSE_CLASS_NAME);
  };

  useEffect(() => {
    const ref = elementRef.current;

    ref?.addEventListener('mousemove', handleMouseMove);
    ref?.addEventListener('keyup', handleKeyboardKeyUp);

    return () => {
      ref?.removeEventListener('mousemove', handleMouseMove);
      ref?.removeEventListener('keyup', handleKeyboardKeyUp);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
